import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Grid,
  makeStyles,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  useMediaQuery,
} from '@material-ui/core'
import { ReactComponent as VisaIcon } from '../../assets/visa_credit_icon.svg'
import FlexView from 'react-flexview/lib'
import { FirebaseConfigKey, FirebaseService } from '../../services/FirebaseService'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'
import { isMobile } from 'react-device-detect'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import BillingApi from '../../api/billing.api'
import './BillingList.scss'
import { ManageRefundPopup } from './ManageRefundPopup'
import { awaitWithLoading } from '../../services/utils'
import ChargesApi from '../../api/charges.api'
import { ApplePayIcon, BankIcon, GooglePayIcon } from '../Core/Icons/PaymentIcons'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import NewFillButton from '../Core/NewFillButton'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import { UserProfileContextStore } from '../../context/UserProfileContext'
import { SessionService } from '../../services/SessionService'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import policymanagementApi from '../../api/policymanagement.api'

import checkMarkGif from '../../assets/7efs.gif'
import { ManageOdometerUploadPopup } from './ManageOdometerUploadPopup'
import chargesApi from '../../api/charges.api'
import { SkyInformationPopover } from '../Core/Popover/SkyPopover'
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    justifyContent: 'center',
    height: 20,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
})

function createData(month, dateAndInvoice, monthlyMileage, paymentMethod, total, isChargedSucceeded, method) {
  let isRefund = false
  if (total < 0) {
    dateAndInvoice = { year: dateAndInvoice.year, date: dateAndInvoice.date, receipt_url: 'Refund' }
    isChargedSucceeded = true
    let isRefund = true
  }
  return {
    month,
    dateAndInvoice,
    monthlyMileage,
    paymentMethod,
    total,
    isChargedSucceeded,
    method,
    isRefund,
  }
}

export const BillingList = () => {
  const myPoliciesContext = React.useContext(PolicyManagementContextStore)
  const NoOpenOdometerRequests =
    myPoliciesContext.all_policies
      .map(p => p.insuredVehicles.filter(iv => iv.have_open_odometer_request && p.policyStatus != 'Scheduled'))
      .flat().length === 0
  const profile = React.useContext(UserProfileContextStore)
  const [rows, setRows] = React.useState([])
  const [openRefundPopup, setOpenRefundPopup] = React.useState(false)
  const [openOdometerUploadPopup, setOpenOdometerUploadPopup] = React.useState(false)
  const [showCheckMark, setShowCheckMark] = React.useState(false)
  const [refundData, setRefundData] = React.useState({
    motorcycles: [],
    refundReason: '',
    refundComment: '',
    insuranceId: '',
  })
  const [openApproveRefund, setOpenApproveRefund] = React.useState({
    open: false,
    amount: 0,
    firstName: '',
    lastName: '',
    isEstimated: false,
  })
  const approveRefundPopup = () =>
    setOpenApproveRefund({
      open: true,
      title: 'Add Motorcycle To DB',
      body: 'Insert motorcycle data',
      action: 'addMotorcycle',
    })

  const renderPaymentIcon = row => {
    switch (row.method) {
      case 'Card':
        return (
          <>
            <VisaIcon className="margin-left-basic text-small" />
            <div className="margin-left-6 text-small">****{row.paymentMethod}</div>
          </>
        )
      case 'ACH':
        return <BankIcon />
      case 'Apple-Pay':
        return <ApplePayIcon />
      case 'Google-Pay':
        return <GooglePayIcon />
      default:
        break
    }
  }

  React.useEffect(() => {
    const loaclLoadBillingReports = async () => {
      await loadBillingReports(myPoliciesContext.billing_reports)
    }
    loaclLoadBillingReports()
  }, [myPoliciesContext.billing_reports])

  const loadBillingReports = async data => {
    let tempRows = []
    data.forEach(report => {
      Object.entries(report).forEach(element => {
        let date = new Date(element[0])
        let data = createData(
          element[1].month,
          {
            date: date.toDateString(),
            receipt_url: element[1].receipt_url,
            year: date.getFullYear().toString().slice(-2),
          },
          element[1].monthly_mileage.toFixed(2),
          element[1].last_for_digits,
          element[1].total_payment.toFixed(2),
          element[1].is_charged,
          element[1].method
        )
        tempRows.push(data)
      })
      setRows(tempRows.sort((a, b) => new Date(b.dateAndInvoice.date) - new Date(a.dateAndInvoice.date)))
    })
  }

  const sendRefundRequest = async data => {
    let res = await ChargesApi.requestRefund(data.policyToRefund.insuranceId, data.requestData.motorcycles)
    if (res.ok) {
      setRefundData({
        motorcycles: data.requestData.motorcycles,
        refundReason: data.requestData.refundReason,
        refundComment: data.requestData.refundComment,
        insuranceId: data.policyToRefund.insuranceId,
      })
      setOpenApproveRefund({
        isEstimated: data.policyToRefund.estimatedMilesInsurance,
        open: true,
        amount: res.data.amount,
        firstName: res.data.first_name,
        lastName: res.data.last_name,
      })
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const sendOdometerUploadRequest = async (insuranceId, data) => {
    const res = await awaitWithLoading(chargesApi.uploadOdometer(insuranceId, data))
    if (res.ok) {
      await showCheck()
      await awaitWithLoading(myPoliciesContext.loadPolicies())
      setOpenOdometerUploadPopup(false)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const approveRefund = async () => {
    let res = await awaitWithLoading(
      ChargesApi.approveRefund(refundData.insuranceId, refundData.motorcycles, refundData.refundReason, refundData.refundComment)
    )
    if (res.ok) {
      await showCheck()
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }
  const afterRefund = async () => {
    let res = await BillingApi.getUserAllBillingHistory()
    let billingReportList = []
    res.data.forEach(billing => {
      billingReportList.push(billing.billing_reports)
    })

    await loadBillingReports(billingReportList)
    //let res = await policymanagementApi.getAllInsurances()
  }

  const showCheck = async () => {
    await awaitWithLoading(afterRefund())
    setShowCheckMark(true)
    const timeId = setTimeout(() => {
      setOpenApproveRefund({ open: false })
      setOpenRefundPopup(false)
      setShowCheckMark(false)
      // After 3 seconds set the show value to false
    }, 5000)
  }

  const classes = useStyles()

  const matches = useMediaQuery('(min-width:1150px)')
  return (
    <Container>
      <Grid container spacing={4} justify={'space-between'} className="margin-top-basic">
        <Grid item xs={8} sm={8} md={8}>
          <div className="text-title blue bold">Billing History</div>
        </Grid>
        <Grid item xs={8} sm={8} md={4}>
          {/* <div className="margin-top-small text-small margin-right-basic"><b>Remaining Credit:</b> xx miles</div> */}
        </Grid>
      </Grid>

      <Grid container spacing={4} justify={'space-between'} className="margin-top-basic">
        {isMobile &&
          rows.map(row => (
            <Accordion className="expansion-container full-width">
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <FlexView className="space-between full-width">
                  <FlexView vAlignContent={'left'} className="bold">
                    {row.month} {row.dateAndInvoice.year}
                  </FlexView>
                  <FlexView vAlignContent={'center'} className="blue">
                    {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                    {row.total}
                  </FlexView>
                </FlexView>
              </AccordionSummary>
              <AccordionDetails>
                <ul className="ul-no-dots">
                  <li>
                    <FlexView className="space-between full-width margin-bottom-medium">
                      <FlexView vAlignContent={'left'} className="bold text-small">
                        Date/Invoice
                      </FlexView>
                      {row.isChargedSucceeded ? (
                        <FlexView column className="blue text-small margin-left-xlarge">
                          <FlexView vAlignContent={'right'}>{row.dateAndInvoice['date']}</FlexView>
                          {!row.isRefund && (
                            <FlexView className="receipt-button">
                              <a href={row.dateAndInvoice['receipt_url']} target="_blank" rel="noreferrer">
                                Receipt
                              </a>
                            </FlexView>
                          )}
                        </FlexView>
                      ) : (
                        <FlexView align="right" className="bold red text-small margin-left-xlarge">
                          Failed Charge
                        </FlexView>
                      )}
                    </FlexView>
                  </li>
                  <li>
                    <FlexView className="space-between full-width margin-bottom-medium">
                      <FlexView vAlignContent={'left'} className="bold text-small">
                        Monthly Mileage
                      </FlexView>
                      <FlexView vAlignContent={'left'} className="text-small">
                        {row.monthlyMileage}
                      </FlexView>
                    </FlexView>
                  </li>
                  <li>
                    <FlexView className="space-between full-width margin-bottom-medium">
                      <FlexView vAlignContent={'left'} className="bold text-small">
                        Payment Method
                      </FlexView>
                      <FlexView className="margin-left-basic-plus">{renderPaymentIcon(row)}</FlexView>
                    </FlexView>
                  </li>
                </ul>
              </AccordionDetails>
            </Accordion>
          ))}

        {!isMobile && (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <StyledTableRow>
                  <TableCell align="center">Month</TableCell>
                  <TableCell align="center">Date/Invoice</TableCell>
                  <TableCell align="center">Monthly Mileage</TableCell>
                  <TableCell align="center">Payment Method</TableCell>
                  <TableCell align="center">Total</TableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow key={row.month}>
                    <TableCell component="th" scope="row" align="center">
                      {row.month}
                    </TableCell>
                    {row.isChargedSucceeded ? (
                      <TableCell align="center">
                        <div>{row.dateAndInvoice['date']}</div>
                        {!row.isRefund && (
                          <div>
                            <a href={row.dateAndInvoice['receipt_url']} target="_blank" rel="noreferrer">
                              Receipt
                            </a>
                          </div>
                        )}
                      </TableCell>
                    ) : (
                      <TableCell align="center">
                        <div className="bold red">Failed Charge</div>
                      </TableCell>
                    )}
                    <TableCell align="center">{row.monthlyMileage}</TableCell>
                    <TableCell align="center">
                      <FlexView className="margin-left-basic-plus">{renderPaymentIcon(row)}</FlexView>
                    </TableCell>
                    <TableCell align="center">
                      {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                      {row.total}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>

      {SessionService.isAdmin() && (
        <div>
          <div className="refund-button">
            <NewFillButton onClick={() => setOpenRefundPopup(true)}>Miles Adjustments</NewFillButton>
          </div>

          <div className="refund-button">
            <NewFillButton
              disabled={NoOpenOdometerRequests}
              style={
                NoOpenOdometerRequests
                  ? {
                      'margin-top': '20px',
                    }
                  : {}
              }
              onClick={() => setOpenOdometerUploadPopup(true)}
            >
              <div style={{ display: 'flex' }}>
                <span>Upload Odometer</span>
                <SkyInformationPopover
                  style={{
                    'margin-top': '3px',
                  }}
                >
                  <div className="text-small">
                    {NoOpenOdometerRequests
                      ? 'No pending odometer requests or policy is not yet active'
                      : 'Use when odometer update is required, it will send validation request'}
                  </div>
                </SkyInformationPopover>
              </div>
            </NewFillButton>
          </div>
        </div>
      )}
      <ManageRefundPopup open={openRefundPopup} onCancel={() => setOpenRefundPopup(false)} onConfirm={sendRefundRequest} />
      <ManageOdometerUploadPopup
        open={openOdometerUploadPopup}
        onCancel={() => setOpenOdometerUploadPopup(false)}
        onConfirm={sendOdometerUploadRequest}
      />

      <SkywatchDialog
        open={openApproveRefund.open}
        circleHeader={
          <ElevatedCircle>
            <AccountCircleIcon className="blue" fontSize="large" />
          </ElevatedCircle>
        }
        maxWidth={'xs'}
        closeDialog={() => setOpenApproveRefund({ open: false })}
      >
        {showCheckMark ? (
          <div className="textcenter">
            Refund request submitted
            <img className="checkMark" src={checkMarkGif} />
          </div>
        ) : (
          <div>
            <div className="textcenter">
              You are about to {openApproveRefund.isEstimated && openApproveRefund.amount > 0 ? 'charge' : 'refund'} customer{' '}
              {openApproveRefund.firstName} {openApproveRefund.lastName} an amount of:{' '}
              {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
              {openApproveRefund.amount}
              <br />
              By clicking 'Approve' the refund will be submitted
            </div>
            <NewFillButton onClick={approveRefund}>Approve</NewFillButton>
          </div>
        )}
      </SkywatchDialog>
    </Container>
  )
}

{
  /* <>
            {<div className="blue bold text-title textcenter">
                You are about to refund customer {openApproveRefund.firstName} {openApproveRefund.lastName} an amount of: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{openApproveRefund.amount}
                <br/>
                 By clicking 'Approve' the refund will be submitted
                </div>
              <NewFillButton onClick={approveRefund}>Approve</NewFillButton></>}
              : */
}
